// ✅ 아바타용 첫 글자 추출 (특수문자/공백 제거 후)
// - 한글 / 영문 / 숫자만 인정
// - 없으면 "?" 반환
export function getAvatarChar(name = "") {
  const s = String(name).trim();

  // ✅ 첫 유효 문자(한글/영문/숫자) 찾기
  const m = s.match(/[A-Za-z0-9가-힣]/);

  if (!m) return "?";

  // 영문이면 대문자 처리
  return /[A-Za-z]/.test(m[0]) ? m[0].toUpperCase() : m[0];
}
